import { useCreateAlarmFromModel } from '@akin-home/alarms/react';
import { useCreateAlertFromModel } from '@akin-home/alerts/frontend';
import { useCreateEventFromModel } from '@akin-home/events/react';
import { useCallback } from 'react';
import { CalendarItemUnion } from '../types';

export const useCreateCalendarItem = () => {
  const createEvent = useCreateEventFromModel();
  const createAlarm = useCreateAlarmFromModel();
  const createAlert = useCreateAlertFromModel();

  return useCallback(
    async (item: CalendarItemUnion) => {
      switch (item.type) {
        case 'Event':
          return createEvent(item);
        case 'Alarm':
          return createAlarm(item);
        case 'Alert':
          return createAlert(item);

        default:
          return undefined;
      }
    },
    [createEvent, createAlarm, createAlert]
  );
};

export default useCreateCalendarItem;
